import { Button, Card, CardContent, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Project } from "../_generated";
import moment from "moment";
import styles from "./InfoTable.module.css";
import { Alert } from "@material-ui/lab";
import InfraRepoDialog from "./InfraRepoDialog";
import axios from "axios";
import { BackendURL } from "../globals";
import { authToken } from "../components/Authentication";
import analytics from "../analytics";

export type ProjectExtended = Project & {
  infra_repo?: string;
};

export function ProjectSettingsPage({ project }: { project: ProjectExtended }) {
  const [showInfraRepoDialog, setShowInfraRepoDialog] = useState(false);

  axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

  async function updateInfraRepository(repoName: string) {
    await axios.put(`${BackendURL}/api/projects/${project.name}/`, {
      ...project,
      infra_repo: repoName,
    });
  }

  useEffect(() => {
    analytics.page("ProjectSettings");
  }, []);

  return (
    <>
      <Grid container justify="center" spacing={2}>
        <Grid item>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6">
                {project.alias || project.name}
              </Typography>
              <table className={styles.infoTable}>
                <tbody>
                  <tr>
                    <th>ID:</th>
                    <td>{project.name}</td>
                  </tr>
                  <tr>
                    <th>Created:</th>
                    <td>
                      {project.date_created
                        ? moment(project.date_updated).toLocaleString()
                        : "never"}
                    </td>
                  </tr>
                  <tr>
                    <th>Last updated:</th>
                    <td>
                      {project.date_updated
                        ? moment(project.date_updated).toLocaleString()
                        : "never"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    Infrastructure repository:{" "}
                    <strong>{project.infra_repo || "not configured"}</strong>
                  </Typography>
                </Grid>
                <Grid item>
                  <Alert severity="info">
                    Digger exports generated Terraform and environment
                    configuration to it, and picks up your overrides and custom
                    changes from there
                  </Alert>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setShowInfraRepoDialog(true)}
                  >
                    Configure infrastructure repository
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <InfraRepoDialog
        projectName={project.name}
        open={showInfraRepoDialog}
        onCancel={() => setShowInfraRepoDialog(false)}
        onSave={(repoName) => {
          setShowInfraRepoDialog(false);
          updateInfraRepository(repoName);
        }}
      />
    </>
  );
}
